import cardIcon from "../../assets/Frame 89.svg";
import smileIcon from "../../assets/Frame 89 (1).svg";
import insuranceIcon from "../../assets/Frame 89 (2).svg";
import arrowImage from "../../assets/Arrow 1.svg";
import teethWhiteIcon from "../../assets/teethwhite.svg";
import { HOME_WRAP, WhatsAppButton } from "./HomeShared";
import { useAppointment } from "../../context/AppointmentContext";

export default function CtaBand() {
  const { openAppointment } = useAppointment();

  return (
    <section className={`${HOME_WRAP} pb-20`}>
      <div className="grid gap-7 rounded-[14px] bg-[#06386f] px-6 py-7 text-white lg:grid-cols-[1.6fr_1fr_1fr_1fr_1.2fr] lg:items-center">
        <div className="flex items-center gap-5">
          <img src={teethWhiteIcon} alt="" className="h-14 w-14 shrink-0" />
          <div>
            <h2 className="text-[23px] font-bold">Ready to love your smile?</h2>
            <p className="mt-1 max-w-[480px] text-[13px] leading-relaxed text-white/90">
              Book your appointment today and take the first step toward a healthier, more confident you.
            </p>
          </div>
        </div>
        <div className="flex items-center gap-3 text-[14px]"><img src={cardIcon} alt="" className="h-10 w-10" /><span>Flexible<br />payment options</span></div>
        <div className="flex items-center gap-3 text-[14px]"><img src={smileIcon} alt="" className="h-10 w-10" /><span>No Judgment.<br />No pain.</span></div>
        <div className="flex items-center gap-3 text-[14px]"><img src={insuranceIcon} alt="" className="h-10 w-10" /><span>All Insurance<br />Accepted</span></div>
        <div className="relative">
          <button
            type="button"
            onClick={openAppointment}
            className="inline-flex w-full items-center justify-center rounded-[10px] bg-white px-6 py-3 text-[17px] font-bold text-[#0052ff] transition hover:bg-[#ffd60a] hover:text-[#071746]"
          >
            Book Appointment
          </button>
          <WhatsAppButton className="mt-3 w-full bg-[#079b65] text-[15px]" />
          <p className="mt-2 text-[13px]">We're ready to help!</p>
          <img src={arrowImage} alt="" className="mt-1 ml-auto h-5 w-[100px]" />
        </div>
      </div>
    </section>
  );
}
